export default __webpack_public_path__ + "static/media/Terms_Conditions.d381553d.png";